import { gql } from '@apollo/client'
import { AccessCardType } from './queryUsersList'
import {
  ParkingSubscriptionStatus,
  ParkingSubscriptionType,
  ReservationStatus,
} from '../tenant/getTenant'
import { IAccessCardFormat } from './queryAccessCardFormat'

export interface IQueryUserVars {
  login: string
}

export interface IAccessCard {
  id: string
  number: string
  type: AccessCardType
  format?: IAccessCardFormat
}

export interface IParkingSubscription {
  id: string
  type: ParkingSubscriptionType
  validFrom: string
  validTo: string
  status: ParkingSubscriptionStatus
  parkingPass?: {
    parking?: {
      name: string
    } | null
  } | null
  daySlots?:
    | {
        day: string
        status: ReservationStatus
      }[]
    | null
  reservations: {
    validFrom: string
    validTo: string
    status: ReservationStatus
    place: {
      name: string
      tenant: {
        name: string
      }
      parking: {
        name: string
      }
    }
  }[]
}

export interface IUser {
  login: string
  accessCard: IAccessCard
  parkingPoolData: {
    id: string
    carPlate?: string
    carPlate2?: string
    enabled?: boolean
  }
  parkingPool: {
    id: string
    profiles: {
      id: string
      name: string
      disabled: boolean
    }[]
  }
  parkingPoolProfile: {
    id: string
    name: string
  }
  tenant: {
    name: string
    seos: {
      disabled: boolean
      id: string
      prefix: string
    }
  }
  parkingSubscriptions: IParkingSubscription[]
}

export interface IQueryUserData {
  queryUser: IUser[]
}

export const QUERY_USER = gql`
  query queryUser($login: String!) {
    queryUser(filter: { login: { eq: $login } }) {
      login
      accessCard: access_card {
        id
        number
        type
        format {
          name
          exampleValue: example_value
          type
          minLength: min_length
          maxLength: max_length
        }
      }
      parkingPoolData: parking_pool_data {
        id
        carPlate: car_plate
        carPlate2: car_plate_2
        enabled
      }
      parkingPool: parking_pool {
        id
        profiles(filter: { not: { disabled: true } }) {
          id
          name
          disabled
        }
      }
      parkingPoolProfile: parking_pool_profile {
        id
        name
      }
      tenant {
        name
        seos {
          disabled
          id
          prefix
        }
      }
      parkingSubscriptions: parking_subscriptions(
        filter: {
          type: { eq: TenantParkingPool }
          and: { not: { status: { in: [past, cancelled] } } }
        }
      ) {
        id
        type
        validFrom: valid_from
        validTo: valid_to
        status
        parkingPass: parking_pass {
          parking {
            name
          }
        }
        daySlots: day_slots {
          day
          status
        }
        reservations {
          validFrom: valid_from
          validTo: valid_to
          status
          place {
            parking {
              name
            }
            name
            tenant {
              name
            }
          }
        }
      }
    }
  }
`
